import { DfAutoComplete } from "./DfAutoComplete";
import {
  AfterViewInit,
  Component,
  ChangeDetectorRef,
  ChangeDetectionStrategy,
  Renderer2,
  ElementRef,
  IterableDiffers,
  Injector,
} from "@angular/core";
import { DomHandler } from "@bfx/primeng/dom";
import { ObjectUtils } from "@bfx/primeng/utils";
import { PositionBookPromiseLookupService } from "shared/cubiq-services";
import {
  AUTOCOMPLETE_VALUE_ACCESSOR,
  AUTOCOMPLETE_VIEW_PROVIDERS,
} from "../../bfx-element-library/bfx-autocomplete.component";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { NativeDesktopSupport } from "app/bfx-native-desktop/native-desktop-support";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { OELoggerService } from "app/order-entry/services/basic/oe-logger.service";
import { BfxFieldSelectDirective } from "../../../shared/base-components/bfx-field-select";
import { BfxInputDirective } from "../../../shared/base-components/bfx-input";

@Component({
  selector: "pos-book-auto",
  templateUrl: "./html/DfAutoComplete.html",
  host: {
    "[class.ui-inputwrapper-filled]": "filled",
    "[class.ui-inputwrapper-focus]": "focus",
  },
  providers: [DomHandler, ObjectUtils, AUTOCOMPLETE_VALUE_ACCESSOR],
  viewProviders: AUTOCOMPLETE_VIEW_PROVIDERS,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PosBookAuto extends DfAutoComplete {
  private isCall: boolean;
  private isRootofCross: boolean;

  constructor(
    private posBookService: PositionBookPromiseLookupService,
    injector: Injector,
    inputDirective: BfxInputDirective,
    fieldDirective: BfxFieldSelectDirective,
    el: ElementRef,
    domHandler: DomHandler,
    renderer: Renderer2,
    objectUtils: ObjectUtils,
    cd: ChangeDetectorRef,
    differs: IterableDiffers,
    oeLogger: OELoggerService,
  ) {
    super(
      injector,
      inputDirective,
      fieldDirective,
      el,
      domHandler,
      renderer,
      objectUtils,
      cd,
      differs,
      oeLogger,
      null,
    );
    this.oeLogger = this.oeLogger.for(__dirname);
  }

  agInit(params: any): void {
    super.agInit(params);
    this.isCall = params.node.data.requestedOrderType == CubiqTS.RequestOrderType.CALL;
    this.isRootofCross = params.node.data.leg1 != undefined && params.node.data.leg2 != undefined;
    if (this.isCancelBeforeStart()) return;
    this.loading = true;
    let pairArr: Array<string> = this.currentData.instrument.split("/");
    let base: string = pairArr[0];
    let nonBase: string = pairArr[1];
    let tradingGroupId: number = Number(this.currentData.deskId);
    if (params.node.data.posBooks) {
      this.fullProvider = params.node.data.posBooks;
      if (this.fullProvider) {
        let selItem: any = null;
        let hilightIdx: number = 0;
        for (let item of this.fullProvider) {
          if (item.label == params.value) {
            selItem = item;
            break;
          }
          hilightIdx++;
        }
        if (null != selItem) {
          this.autoHighlightIndex = hilightIdx;
        }
        this.suggestions = this.fullProvider.concat();
        this.writeValue(selItem);
      }
    } else {
      this.posBookService
        .getPositionBooksForPairAndTradingGroup(base, nonBase, tradingGroupId, undefined)
        .then((values) => {
          this.fullProvider = values.root.books;
          if (this.fullProvider) {
            let selItem: any = null;
            let hilightIdx: number = 0;
            for (let item of this.fullProvider) {
              if (item.label == params.value) {
                selItem = item;
                break;
              }
              hilightIdx++;
            }
            if (null != selItem) {
              this.autoHighlightIndex = hilightIdx;
            }
            this.suggestions = this.fullProvider.concat();
            this.writeValue(selItem);
          }
        });
    }
  }

  isCancelBeforeStart?(): boolean {
    return (
      this.isCall ||
      (this.isComponentLeg && !this.legEnabled) ||
      (!this.isComponentLeg && !this.isRowSelected) ||
      this.isRootofCross
    );
  }

  isCancelAfterEnd?(): boolean {
    if (
      this.isCall ||
      (this.isComponentLeg && !this.legEnabled) ||
      (!this.isComponentLeg && !this.isRowSelected) ||
      this.isRootofCross
    )
      return true;
    if (this.value) {
      this.currentData.positionBookName = this.value.value;
      this.currentData.positionBookId = this.value.value;
      this.currentData.positionBookBranch = this.value.branch;
    }
    return this.value == null || this.value == undefined;
  }
}
